import React, {Component, useState} from 'react';
import {useCompanyLogo} from '../../queries/companyLogo';
import InfinitProgressBar from '../InfiniteProgressBar';


function Logo(props){
    const {error, loading, data} = useCompanyLogo(); 
    if(loading) return 
    <InfinitProgressBar/>
    if(error) return <div>error!</div>
      
    
        return (
            <div className="logo-area">
                <a href="/"><img src={process.env.REACT_APP_BASE_URL + data.companyLogo[0].image.urls[0]} alt="Businex-Logo"  style={{width:"215px"}} /></a>
            </div>
        );
    }

export default Logo;
